/**
 * Observe element size changes without flooding layout in the same frame.
 * Using requestAnimationFrame avoids the common
 * "ResizeObserver loop completed with undelivered notifications" warning.
 */
export function observeElementSize(element, onSize) {
  if (!element || typeof ResizeObserver === 'undefined') {
    return () => {};
  }

  let frameId = null;

  const observer = new ResizeObserver(() => {
    if (frameId != null) {
      cancelAnimationFrame(frameId);
    }

    frameId = requestAnimationFrame(() => {
      frameId = null;
      onSize();
    });
  });

  observer.observe(element);

  return () => {
    if (frameId != null) {
      cancelAnimationFrame(frameId);
    }
    observer.disconnect();
  };
}
